function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_87",
  "data-name": "Group 87",
  transform: "translate(0.044 -0.004)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_80",
  "data-name": "Ellipse 80",
  cx: 3.385,
  cy: 3.385,
  r: 3.385,
  transform: "translate(6.462 20.151)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1194",
  "data-name": "Path 1194",
  d: "M8.663,19.287,4.431,3.97.2,1.6",
  transform: "translate(0 -0.151)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_120",
  "data-name": "Line 120",
  y1: 2.454,
  x2: 8.716,
  transform: "translate(14.248 19.898)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1195",
  "data-name": "Path 1195",
  d: "M13.57,20.171,11.2,11.708,21.1,9l2.708,9.817-8.632,2.37",
  transform: "translate(-1.691 -1.289)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1683",
  "data-name": "Rectangle 1683",
  width: 7.955,
  height: 7.955,
  transform: "translate(7.412 2.733) rotate(-15.415)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1196",
  "data-name": "Path 1196",
  d: "M11.8,4.146l.508,1.693,3.3-.931L15.1,3.3",
  transform: "translate(-1.783 -0.412)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1197",
  "data-name": "Path 1197",
  d: "M15.6,12.846l.508,1.693,3.216-.931L18.9,12",
  transform: "translate(-2.368 -1.75)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
}));

var SvgIconFreightWhite = function SvgIconFreightWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.144,
    height: 27.418,
    viewBox: "0 0 23.144 27.418",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFreightWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_freight_white.5ac95d0c.svg";
export { ForwardRef as ReactComponent };